import React from 'react';

// Importar los logos
import logoFull from '../assets/branding/logos/retoma-logo-full.png';
import logoWhite from '../assets/branding/logos/retoma-logo-white.png';
import logoHorizontal from '../assets/branding/logos/retoma-logo-horizontal.png';
import logoSymbol from '../assets/branding/logos/retoma-logo-symbol.svg';

const Logo = ({ 
  variant = 'horizontal', // 'full', 'horizontal', 'white', 'symbol'
  size = 'medium', // 'small', 'medium', 'large'
  className = '',
  onClick = null 
}) => {
  // Seleccionar el logo según la variante
  const getLogoSrc = () => {
    switch (variant) {
      case 'full':
        return logoFull;
      case 'white':
        return logoWhite;
      case 'horizontal':
        return logoHorizontal;
      case 'symbol':
        return logoSymbol;
      default:
        return logoHorizontal;
    }
  };

  // Definir tamaños según el contexto
  const getSizeStyles = () => {
    switch (size) {
      case 'small':
        return { height: '24px', width: 'auto' };
      case 'medium':
        return { height: '32px', width: 'auto' };
      case 'large':
        return { height: '48px', width: 'auto' };
      default:
        return { height: '32px', width: 'auto' };
    }
  };

  const logoStyles = {
    ...getSizeStyles(),
    cursor: onClick ? 'pointer' : 'default',
    transition: 'all 0.3s ease'
  };

  return (
    <div className={`logo ${className}`} onClick={onClick}>
      <img 
        src={getLogoSrc()} 
        alt="Refurbi" 
        style={logoStyles}
        onError={(e) => {
          // Fallback en caso de error al cargar la imagen
          e.target.style.display = 'none';
          e.target.nextSibling.style.display = 'inline';
        }}
      />
      {/* Fallback text en caso de que no cargue la imagen */}
      <span style={{ display: 'none', fontSize: '1.5rem', fontWeight: 'bold' }}>
        Refurbi
      </span>
    </div>
  );
};

export default Logo; 